import { render } from "./FacilityRequestTab.vue?vue&type=template&id=483e1330"
import script from "./FacilityRequestTab.vue?vue&type=script&lang=js"
export * from "./FacilityRequestTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__